$(function() {

	var cleanInputs = function() {

		if(!$("#prompt-form").length) {
			return;
		}
		
		$("input[type='hidden']", $("#prompt-hidden")).each(function() {
			if($(":input[name='" + $(this).attr("name") + "']", $("#prompt-visible")).length) {
				$(this).remove();
			}
		});

		var actionUrl = $("#prompt-form").attr("action");
		if(actionUrl && actionUrl.indexOf("?") > 0) {
			actionUrl = actionUrl.substring(0, actionUrl.indexOf("?"));
			$("#prompt-form").attr("action", actionUrl);
		}
	};
	
	$(document).on("form.init", cleanInputs);
	cleanInputs();

	var showSelectedItemsCountTable = $("table.show-selected-items-count-in-header");
	if (showSelectedItemsCountTable.length) {

		var promptHeader = $("#prompt-header");

		var checkOneCheckboxes = showSelectedItemsCountTable.find(":input[type='checkbox'].check-one");
		var totalCount = checkOneCheckboxes.length;

		if (!totalCount) {
			return;
		}

		function onCheckboxChange() {

			var checkedCount = checkOneCheckboxes.filter(":checked").length;

			var newCheckedCountElementText = " (" + ebusy.countSelectedText
				.replace("{0}", checkedCount)
				.replace("{1}", totalCount) + ")";

			var checkedCountElement = promptHeader.find(".checked-count");

			if (checkedCountElement.length) {
				if (newCheckedCountElementText !== checkedCountElement.text()) {
					checkedCountElement.text(newCheckedCountElementText);
				}
				return;
			}

			var newCheckedCountElement = $('<h4 />')
				.attr("class", "checked-count")
				.text(newCheckedCountElementText);

			promptHeader.append(newCheckedCountElement);
		}

		checkOneCheckboxes.on("change", onCheckboxChange);
		onCheckboxChange();
	}
});
